(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.announcementBar) {
          this.announcementBar.classList.add('shopify-section-header-sticky');
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcementBar) {
          this.announcementBar.classList.add('scrolled-past-header');
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcementBar) {
          this.announcementBar.classList.add('scrolled-past-header');
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.announcementBar) {
          this.announcementBar.classList.remove('scrolled-past-header');
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Hover intent for the desktop mega menu. The panel opens after a short
  // dwell so a cursor merely crossing the nav does not flash panels open, and
  // closes on a grace delay so the diagonal move from the trigger down into
  // the panel is forgiving. Both timers are cancelled if the pointer returns.
  const HANLYN_MEGA_MENU_OPEN_DELAY = 120;
  const HANLYN_MEGA_MENU_CLOSE_DELAY = 200;
  const HANLYN_MEGA_MENU_DESKTOP_QUERY = '(min-width: 990px)';

  class HanlynMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.header__menu-link');
      this.panel = this.querySelector('.hanlyn-mega-menu__panel');
      this.overlay = this.querySelector('.hanlyn-mega-menu__overlay');
      this.isOpen = false;
      this.eventsAttached = false;
      this.breakpointBound = false;
      this.openTimer = null;
      this.closeTimer = null;
      this.suppressFocusOpen = false;

      // Bind methods
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleTriggerFocus = this.handleTriggerFocus.bind(this);
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handlePointerLeave = this.handlePointerLeave.bind(this);
      this.handleOverlayPointerEnter = this.handleOverlayPointerEnter.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.trigger = this.trigger || this.querySelector('.header__menu-link');
      this.panel = this.panel || this.querySelector('.hanlyn-mega-menu__panel');
      this.overlay = this.overlay || this.querySelector('.hanlyn-mega-menu__overlay');

      if (!this.trigger || !this.panel) return;

      // Desktop only - min-width: 990px. Below that the panel is display:none
      // and the hamburger drawer owns the navigation, so nothing is bound.
      if (!this.desktopQuery && typeof window.matchMedia === 'function') {
        this.desktopQuery = window.matchMedia(HANLYN_MEGA_MENU_DESKTOP_QUERY);
      }

      if (this.desktopQuery && !this.breakpointBound) {
        if (typeof this.desktopQuery.addEventListener === 'function') {
          this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
        } else if (typeof this.desktopQuery.addListener === 'function') {
          this.desktopQuery.addListener(this.handleBreakpointChange);
        }
        this.breakpointBound = true;
      }

      if (this.isDesktop()) {
        this.attachEventListeners();
      }
    }

    disconnectedCallback() {
      this.clearHoverTimers();
      this.removeEventListeners();

      if (this.desktopQuery && this.breakpointBound) {
        if (typeof this.desktopQuery.removeEventListener === 'function') {
          this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
        } else if (typeof this.desktopQuery.removeListener === 'function') {
          this.desktopQuery.removeListener(this.handleBreakpointChange);
        }
        this.breakpointBound = false;
      }
    }

    isDesktop() {
      return this.desktopQuery ? this.desktopQuery.matches : window.innerWidth >= 990;
    }

    handleBreakpointChange() {
      if (this.isDesktop()) {
        this.attachEventListeners();
      } else {
        this.clearHoverTimers();
        this.close();
        this.removeEventListeners();
      }
    }

    attachEventListeners() {
      if (this.eventsAttached || !this.trigger || !this.panel) return;

      // Keydown is bound on the host so Escape also works once focus has moved
      // into the panel; the handler itself scopes ArrowDown to the trigger.
      this.addEventListener('keydown', this.handleKeydown);

      // The panel is a DOM descendant of this element, so moving from the
      // trigger down into the panel never leaves this element and never fires
      // pointerleave - the panel stays open, which is what we want. The
      // full-viewport scrim is a descendant too, so it gets its own
      // pointerenter to stand in for "the pointer left the menu", and the
      // trigger and panel each get a pointerenter so coming back off the scrim
      // cancels that pending close even though the host was never re-entered.
      this.addEventListener('pointerenter', this.handlePointerEnter);
      this.addEventListener('pointerleave', this.handlePointerLeave);
      this.trigger.addEventListener('pointerenter', this.handlePointerEnter);
      this.panel.addEventListener('pointerenter', this.handlePointerEnter);

      this.trigger.addEventListener('focus', this.handleTriggerFocus);

      if (this.overlay) {
        this.overlay.addEventListener('click', this.handleOverlayClick);
        this.overlay.addEventListener('pointerenter', this.handleOverlayPointerEnter);
      }

      this.eventsAttached = true;
    }

    removeEventListeners() {
      this.removeEventListener('keydown', this.handleKeydown);
      this.removeEventListener('pointerenter', this.handlePointerEnter);
      this.removeEventListener('pointerleave', this.handlePointerLeave);
      if (this.trigger) {
        this.trigger.removeEventListener('pointerenter', this.handlePointerEnter);
        this.trigger.removeEventListener('focus', this.handleTriggerFocus);
      }
      if (this.panel) {
        this.panel.removeEventListener('pointerenter', this.handlePointerEnter);
      }
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.handleOverlayClick);
        this.overlay.removeEventListener('pointerenter', this.handleOverlayPointerEnter);
      }
      document.removeEventListener('click', this.handleDocumentClick);
      this.eventsAttached = false;
    }

    clearHoverTimers() {
      if (this.openTimer) {
        clearTimeout(this.openTimer);
        this.openTimer = null;
      }
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }

    scheduleOpen() {
      this.clearHoverTimers();
      if (this.isOpen) return;
      this.openTimer = setTimeout(() => {
        this.openTimer = null;
        this.open();
      }, HANLYN_MEGA_MENU_OPEN_DELAY);
    }

    scheduleClose() {
      this.clearHoverTimers();
      if (!this.isOpen) return;
      this.closeTimer = setTimeout(() => {
        this.closeTimer = null;
        this.close();
      }, HANLYN_MEGA_MENU_CLOSE_DELAY);
    }

    handlePointerEnter(event) {
      if (event && event.pointerType === 'touch') return;
      if (!this.isDesktop()) return;
      this.scheduleOpen();
    }

    handlePointerLeave(event) {
      if (event && event.pointerType === 'touch') return;
      if (!this.isDesktop()) return;
      this.scheduleClose();
    }

    handleOverlayPointerEnter(event) {
      if (event && event.pointerType === 'touch') return;
      if (!this.isDesktop()) return;
      this.scheduleClose();
    }

    handleTriggerFocus() {
      if (this.suppressFocusOpen) return;
      if (!this.isDesktop()) return;
      this.clearHoverTimers();
      this.open();
    }

    focusTrigger() {
      if (!this.trigger) return;
      // Guard against the focus handler immediately re-opening what we closed.
      this.suppressFocusOpen = true;
      this.trigger.focus();
      setTimeout(() => {
        this.suppressFocusOpen = false;
      }, 0);
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        if (!this.isOpen) return;
        event.preventDefault();
        this.clearHoverTimers();
        this.close();
        this.focusTrigger();
        return;
      }

      // Everything below is trigger-only so arrow keys inside the panel are
      // left to the browser.
      if (event.target !== this.trigger) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.clearHoverTimers();
        if (!this.isOpen) {
          this.open();
        } else {
          this.focusFirstLink();
        }
      }

      // Enter and Space are deliberately not intercepted: the trigger is a real
      // collection link and must activate the way any link does.
    }

    handleDocumentClick(event) {
      // Close if clicking outside
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    handleOverlayClick(event) {
      event.preventDefault();
      this.clearHoverTimers();
      this.close();
      this.focusTrigger();
    }

    open() {
      if (this.isOpen || !this.trigger || !this.panel) return;

      // Close any other open mega menus - only one panel open at a time
      document.querySelectorAll('hanlyn-mega-menu').forEach(menu => {
        if (menu !== this && typeof menu.close === 'function') menu.close();
      });

      this.isOpen = true;
      this.panel.setAttribute('aria-hidden', 'false');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');

      // Prevent body scrolling
      document.body.classList.add('mega-menu-open');

      // Listen for outside clicks
      document.removeEventListener('click', this.handleDocumentClick);
      setTimeout(() => {
        if (this.isOpen) document.addEventListener('click', this.handleDocumentClick);
      }, 0);
    }

    close() {
      if (!this.isOpen) return;

      this.isOpen = false;
      if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
      if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-open');

      // Restore body scrolling
      document.body.classList.remove('mega-menu-open');

      document.removeEventListener('click', this.handleDocumentClick);
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    focusFirstLink() {
      if (!this.panel) return;
      const firstLink =
        this.panel.querySelector('.hanlyn-mega-menu__nav-link') || this.panel.querySelector('a[href]');
      if (firstLink) firstLink.focus();
    }
  }

  if (!customElements.get('hanlyn-mega-menu')) {
    customElements.define('hanlyn-mega-menu', HanlynMegaMenu);
  }

  } catch(e) { console.error(e); }
})();
})();
